
import React from 'react';
import { Alert } from 'reactstrap';

const ResponseBox = ({ type, response }) => {
  if (type === 0) { return null }

  let color, message;
  switch (type) {
    case 1:
      color = 'success';
      message = 'Guardado!';
      break;
    case 2:
      color = 'danger';
      message = 'Error!';
      break;
    default: break;
  }

  return (
    <Alert color={color}>
      <span>{message} {response}</span>
    </Alert>
  )
}

export default ResponseBox;
